import { render, staticRenderFns } from "./MPCHeader.vue?vue&type=template&id=4aec54a9&"
import script from "./MPCHeader.vue?vue&type=script&lang=js&"
export * from "./MPCHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports